
// desktop.module.js

"use strict";

import angular from "angular";
import {
    BXDataListComponent,
    BXDataListAjaxComponent
}   from "./pagination/pagination.module"



const COMPONENTS_MODULE = angular
  .module("moetp.components", [])
  .component("bxPagination", new BXDataListComponent())
  .component("bxPaginationAjax", new BXDataListAjaxComponent())
  
  

export { COMPONENTS_MODULE };

  


// WEBPACK FOOTER //
// ./src/components/components.module.js